import httpAdminClient from '@/plugins/httpAdminClient';

export default {
  getRooms() {
    return httpAdminClient.get('admin/meeting/rooms');
  },
  createRoom(data) {
    return httpAdminClient.post('admin/meeting/rooms', { meeting_room: { ...data } });
  },
  patchRoom(id, data) {
    return httpAdminClient.patch(`admin/meeting/rooms/${id}`, { meeting_room: { ...data } });
  },
  deleteRoom(id) {
    return httpAdminClient.delete(`admin/meeting/rooms/${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/adminApis/meeting/roomsApis.js